import React, { useEffect, useState } from 'react';
import { HTMLContent } from '../../common/components/html-content';
import SubscribeDetailsModal from './subscribe-membership-modal';
import Popup from '../../common/components/popup';

export default function MembershipCard({ membership }: any) {
  const defaultImage = require('../../assets/img/membership default.jpg');
  const [showServices, setShowServices] = useState(false);
  const [selectMembership, setSelectMembership] = useState<any>({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const imageUrl =
    membership?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL || defaultImage;
  const ONEMemberships = membership?.ONEMemberships?.[0]?.EntityInfo;

  const handleSubscribe = (membership: any) => {
    setSelectMembership(membership);
    setShowModal(true);
  };

  const closeModals = () => {
    setShowModal(false);
    setSelectMembership({});
  };

  const NewItemPopups = () => (
    <Popup onClose={closeModals}>
      <SubscribeDetailsModal Close={closeModals} />
    </Popup>
  );


  return (
    <>
      {showModal && <NewItemPopups />}
      <div className="p-6 rounded-2xl shadow-md border border-gray-200 bg-white flex flex-col justify-between 
        min-h-[600px] max-h-[500px] w-full overflow-hidden">

        <div className="flex-grow overflow-y-auto pr-1">
          <div className="text-xl font-bold text-blue-600 uppercase tracking-widest">
            {membership?.Name}
          </div>

          <div className="text-l font-extrabold text-gray-900 mt-1">
            {ONEMemberships?.Name}
          </div>

          <div className="mt-3 text-sm text-gray-600 leading-relaxed">
            {ONEMemberships?.Description}
          </div>

          <img
            src={imageUrl}
            alt={membership?.Name}
            className="w-full h-32 object-contain mt-4"
          />

          <div className="mt-3 text-sm text-gray-600 leading-relaxed">
            {ONEMemberships?.IncludedServices && (
              <div className="[&_ul]:list-disc [&_ul]:list-outside [&_li]:ml-4 text-left">
                <HTMLContent htmlContent={ONEMemberships.IncludedServices} />
              </div>
            )}
          </div>
        </div>

        {/* Bottom Price + Button */}
        <div className="mt-6">
          <div className="flex items-center text-lg font-bold text-gray-900">
            <span className="text-yellow-500 mr-2">💰</span>
            Price:{" "}
            {ONEMemberships?.IsFreeOfCost ? (
              "Free Cost"
            ) : ONEMemberships?.Price && ONEMemberships.Price > 0 ? (
              <>₹{ONEMemberships.Price.toLocaleString("en-IN")}</>
            ) : (
              "Contact us for price"
            )}
          </div>


          <button
            onClick={() => handleSubscribe(membership)}
            className="w-full mt-4 py-2 px-4 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg shadow hover:opacity-90 transition"
          >
            Join Now
          </button>
        </div>
      </div>
    </>
  );
}
